// import { colors } from "../../../../utils"

export const sx ={ 
    width: 250, 
    marginLeft: 2, 
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
        // color: colors.greyPlaceholder
    }
}